import TextureFileType from "./enums/TextureFileType";

class TextureFile {
  constructor(
    public id: number,
    public texture_type: TextureFileType,
    public name?: string | undefined,
    // used only locally for data transfer between components
    public error?: string | undefined,
    // end local fields
    public id_reference?: number | undefined,
    public name_reference?: string | undefined,
  ) {}
}

export default TextureFile;
